<template>
  <v-row class="mb-auto" justify="center" id="hgzprint">
    <v-col cols="12">
      <div align="right">
        <v-btn small color="primary" dark @click="activeAll">激活全部</v-btn>
      </div>
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table show-select @toggle-select-all="selectAll" :multi-sort="false" v-model="selected" item-key="Id"
        :headers="headers" :items="mainData" :items-per-page="limit" :options.sync="options"
        :server-items-length="countData" :loading="loading" class="elevation-1 text-no-wrap" show-group-by
        :footer-props="{ itemsPerPageText: '分页:', 'items-per-page-options':[10,20,30,50,100,-1] }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>合格证</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn small :color="issearch ? 'error' : 'success'" dark class="mr-2" @click="issearch = !issearch">
              <v-icon>{{ issearch ? "mdi-magnify-close" : "mdi-magnify" }}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="success" dark @click="activeSelect">
              激活 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.Status="{ item }">
          <v-switch color="success" class="d-inline-block ml-2" :loading="loading" v-model="item.Status"
            @click="activeHgz(item)"></v-switch>
          <span :class="item.Status ? 'success--text' : 'error--text'"></span>
        </template>
        <template v-solt:footer.page-text="{ item }">
          <v-btn color="success">text</v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="info" class="mr-4" @click="cid=item.Id;dialog = true">mdi-eye</v-icon>
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" max-width="400">
        <div align="right" class="success lighten-1">
          <v-icon large @click="dialog = false" class="px-2">mdi-close</v-icon>
        </div>
        <v-sheet :height="$vuetify.breakpoint.xsOnly?'530':'750'" max-height="90%">
          <iframe :src="'/c/'+cid+'/yulan'" width="100%" height="100%"></iframe>
        </v-sheet>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
  import search from "@/components/search";
  export default {
    components: {
      search,
    },
    data: function () {
      return {
        dialog: false,
        cid: 1,
        selected: [],
        headers: [{
          text: "产品",
          value: "PiCier.Producter.Name",
          groupable: false,
        },
        {
          text: "生产者",
          value: "PiCier.Userer.Name",
          groupable: false,
        },
        {
          text: "批次",
          value: "PiCier.PiCi",
          groupable: false,
        },
        {
          text: "数量",
          value: "ProductNums",
          groupable: false,
        },
        {
          text: "单位",
          value: "ProductUnit",
          groupable: false,
        },
        {
          text: "份数",
          value: "PrintNums",
          groupable: false,
        },
        {
          text: "开具日期",
          value: "DateAt",
          groupable: false,
        },
        {
          text: "激活",
          value: "Status",
          groupable: false,
        },
        { text: "创建时间", value: "CreateAt", groupable: false },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          groupable: false
        },
        ],
        issearch: false,
        mainData: [],
        countData: 0,
        offset: 0,
        limit: this.$store.state.glimit,
        query: "",
        exclude: "",
        sortby: "",
        order: "",
        options: {},
        loading: false,
      };
    },
    watch: {
      options: {
        handler() {
          //立即执行
          this.limit = this.options.itemsPerPage;
          this.offset = (this.options.page - 1) * this.limit;
          this.sortby = "";
          this.order = "";
          for (let index = 0; index < this.options.sortBy.length; index++) {
            this.sortby += this.options.sortBy[index] + ",";
            this.order += this.options.sortDesc[index] ? "desc," : "asc,";
          }
          if (this.sortby.length > 0) {
            this.sortby = this.sortby.slice(0, -1);
            this.order = this.order.slice(0, -1);
          } else {
            this.sortby = "Status,Id";
            this.order = "asc,desc";
          }
          this.initialize();
        },
        deep: true, //对象深度监听
      },
    },
    methods: {
      activeAll() {
        if (!confirm("确认激活系统中的全部合格证吗?")) return;
        this.loading = true
        this.$api.activeAllHgz().then(res => {
          this.loading = false;
          this.mainData.forEach(element => {
            if (!element.Status) element.Status = true
          });
        }).catch(error => {
          this.loading = false;
          let message = (error && error.msg) || "激活全部合格证失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      activeSelect() {
        if (!confirm("确认激活选中的合格证吗?")) return;
        if (this.selected.length > 0) {
          let ids = "";
          let arrid = [];
          for (let index = 0; index < this.selected.length; index++) {
            ids += this.selected[index].Id + ",";
            arrid.push(this.selected[index].Id);
          }
          if (ids.length > 0) {
            ids = ids.slice(0, -1);
          }
          this.loading = true
          this.$api.activeSelectHgz({
            id: ids
          }).then((res) => {
            this.loading = false
            for (let index = 0; index < arrid.length; index++) {
              this.mainData.forEach(element => {
                if (!element.Status && element.Id == arrid[index]) element.Status = true
              });
            }
          }).catch((error) => {
            this.loading = false
            let message = (error && error.msg) || "激活选中选失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$store.commit("setsnack", { message: "尚未选择任何项目", color: "warning", });
        }
      },
      activeHgz(item) {
        this.loading = true
        this.$api.setHgzStatus({ Id: item.Id, Status: item.Status }).then(res => {
          this.loading = false;
        }).catch(error => {
          this.loading = false;
          item.Status = !item.Status
          let message = (error && error.msg) || "改变合格证状态失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      querydata(query, exclude) {
        this.query = query;
        this.exclude = exclude;
        this.initialize();
      },
      selectAll(item) {
        this.selected = item.value ? item.items : [];
      },
      delselect() {
        if (!confirm("确认删除所有选中项吗?")) return;
        if (this.selected.length > 0) {
          let ids = "";
          let arrid = [];
          for (let index = 0; index < this.selected.length; index++) {
            ids += this.selected[index].Id + ",";
            arrid.push(this.selected[index].Id);
          }
          if (ids.length > 0) {
            ids = ids.slice(0, -1);
          }
          this.loading = true
          this.$api.delHgz({
            id: ids
          }).then((res) => {
            this.loading = false
            for (let index = 0; index < arrid.length; index++) {
              this.mainData = this.mainData.filter(
                (item) => item.Id != arrid[index]
              );
            }
            this.countData -= arrid.length;
          }).catch((error) => {
            this.loading = false
            let message = (error && error.msg) || "删除选中选失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$store.commit("setsnack", { message: "尚未选择任何项目", color: "warning", });
        }
      },
      initialize() {
        let data = {
          limit: this.limit,
          offset: this.offset,
        };
        if (this.query != "") {
          data.query = this.query;
        }
        if (this.exclude != "") {
          data.exclude = this.exclude;
        }
        if (this.sortby != "") {
          data.sortby = this.sortby;
          data.order = this.order;
        }
        this.loading = true;
        this.$api.getHgzs(data).then((res) => {
          this.loading = false;
          if (res.data) {
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        }).catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      deleteItem(item) {
        const index = this.mainData.indexOf(item);
        if (confirm("确认删除此项数据吗?")) {
          const data = {
            id: item.Id,
          };
          this.loading = true
          this.$api.delHgz(data).then((res) => {
            this.loading = false
            this.mainData.splice(index, 1);
            this.countData--;
          }).catch((error) => {
            this.loading = false
            let message = (error && error.msg) || "删除失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
    },
  };
</script>